import { screen } from 'components/styles/variables';
import FavoriteIcon from 'components/FavoriteIcon';
import buttonCSS from 'components/styles/button';
import VehicleItemBadges from 'components/VehicleBadges';
import css from 'styled-jsx/css';
import { Badge } from 'components/VehicleBadges/types';
import { trackRemoveFavorite, trackViewFavoriteClick } from 'lib/Tracking/FavoritesPage';
import { useDispatch } from 'react-redux';
import { removeFavorite } from 'redux-implementations/favorites';
import { AppDispatch } from 'redux-implementations/makeStore';
import classNames from 'classnames';
import styles from './styles';
import CardInfo, { CardInfoProps } from '../CardInfo';

export interface ActiveFavoriteCardProps {
  id: number;
  vin: string;
  make: string;
  model: string;
  trim: string;
  year: number;
  mileage: string;
  price: string;
  city: string;
  state: string;
  monthlyPayment?: number;
  vdpUrl: string;
  thumbnailImg: string;
  badges?: Badge[];
  isAcceptingOffers: boolean;
}

const heartCss = css.resolve`
  .heart {
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: 1;
  }

  @media (min-width: ${screen.smMin}) {
    .heart {
      top: 24px;
      left: 231px;
    }
  }
`;

const ActiveFavoriteCard = ({
  vin,
  make,
  model,
  year,
  trim,
  mileage,
  price,
  city,
  state,
  monthlyPayment,
  vdpUrl,
  thumbnailImg,
  badges,
  isAcceptingOffers,
}: ActiveFavoriteCardProps): JSX.Element => {
  const dispatch = useDispatch<AppDispatch>();
  const onHeartClick = (): void => {
    trackRemoveFavorite(vin);
    dispatch(removeFavorite(vin));
  };
  const onCardClick = (): void => trackViewFavoriteClick(vin, vdpUrl);
  const cardInfoProps: CardInfoProps = {
    year,
    make,
    model,
    trim,
    mileage,
    city,
    state,
    price,
    monthlyPayment,
    isAcceptingOffers,
  };

  return (
    <div className={`card-container`} data-testid="active-card">
      <FavoriteIcon
        className={classNames('heart', heartCss.className)}
        onClick={onHeartClick}
        active={true}
      />
      <a href={vdpUrl} onClick={onCardClick} className="srp-card">
        <div className="image-container">
          <img className="listing-image" src={thumbnailImg} alt={`${make} ${model}`} />
          {badges && (
            <div className="badges">
              <VehicleItemBadges badges={badges} />
            </div>
          )}
        </div>
        <CardInfo {...cardInfoProps} />
      </a>
      <style jsx>{styles}</style>
      <style jsx>{buttonCSS}</style>
      {heartCss.styles}
    </div>
  );
};

export default ActiveFavoriteCard;
